import Vue from 'vue';
import './shared/quiz/quiz_question';
import Utils from '../../shared/utils';
import flash from '../../shared/flash';
import BaseQuizViewer from '../../shared/content_managers/quiz.base';
import _ from 'underscore';
import Comments from '../../comments/comments';

export default class SingleQuizContentViewer extends BaseQuizViewer {
  get dirty() {
    return false;
  }

  constructor(context, remote, options) {
    super(context, remote, options);
  }

  parseResult(content) {
    for (var i = 0; i < content.questions.length; i++) {
      for (var j = 0; j < content.questions[i].alternatives.length; j++) {
        content.questions[i].alternatives[j].answered =
          content.answers[content.questions[i].id] == content.questions[i].alternatives[j].id;
      }
    }

    content.results = {};
    _.each(content.answers, function (alternative_id, question_id) {
      content.results['_' + question_id] = alternative_id;
    });

    this.data = content;

    let result = {
      cnt: $(
        Handlebars.templates['behaviors/quiz/viewer_single'](
          $.extend(
            {
              navigation: this.options.navigation,
              node: {
                name: this.context.getName(),
                image: this.context.getImage(),
              },
            },
            content,
          ),
        ),
      ),
    };

    return result;
  }

  _setup() {
    let that = this;

    let states = {
      START: 0,
      ONGOING: 1,
      CORRECTED: 2,
    };

    this.editor = new Vue({
      el: this.panel.content.find('.lp--js-quizHook')[0],
      template: `
        <ol class="lp--quizWidget-questions" v-bind:class="{'lp--quizWidget-questionsSkipActive': options.locked}">
          <quiz-question v-for="(question, index) in questions" :key="(question.key || question.id || index)" :question="question" :displayResults="displayResults" :displayCorrect="displayCorrect" :isCurrent="question == currentQuestion" :options="options" @questionAnswered="questionAnswered" :index="index" />
        </ol>
      `,
      methods: {
        stepQuestion: function (direction) {
          if (this.currentQuestion) {
            let question_index = this.questions.indexOf(this.currentQuestion);
            question_index = question_index + direction;
            if (question_index > -1 && question_index < this.questions.length) {
              this.setCurrentQuestion(this.questions[question_index]);
            }
          }
        },
        questionAnswered: function (question, idx) {
          if (this.state == states.START || this.state == states.CORRECTED) {
            this.reset();
          }
          question.alternatives.forEach(function (alternative) {
            Vue.set(alternative, 'answered', false);
          });
          let alternative = question.alternatives[idx];
          Vue.set(alternative, 'answered', !alternative.answered);
          Vue.set(question, 'key', question.id + Date.now());
          this.results['_' + question.id] = alternative.id;

          let question_index = this.questions.indexOf(question);
          if (question_index + 1 < this.questions.length) {
            this.setCurrentQuestion(this.questions[question_index + 1]);
          }
          this.state = states.ONGOING;
          that.footer.questionUpdated(JSON.parse(JSON.stringify(this.questions)));
        },
        getAnswers: function () {
          return JSON.parse(JSON.stringify(this.results));
        },
        reset: function () {
          this.state = states.START;
          this.currentQuestion = false;
          this.displayCorrect = false;
          this.results = {};
          for (var i = 0; i < this.questions.length; i++) {
            for (var j = 0; j < this.questions[i].alternatives.length; j++) {
              this.questions[i].alternatives[j].answered = false;
            }
          }
        },
        start: function () {
          this.reset();
          this.currentQuestion = this.questions[0];
          this.state = states.ONGOING;
          that.panel.content[0].scrollTop = 0;
        },
        setCurrentQuestion: function (question) {
          this.currentQuestion = question;
          this.scrollToQuestion(this.currentQuestion);
          let index = this.questions.indexOf(question);
          that.footer.setQuestionIndex(index);
        },
        showResults: function (footer) {
          this.state = states.CORRECTED;
          this.displayCorrect = true;
          let result = 0;

          for (var i = 0; i < this.questions.length; i++) {
            for (var j = 0; j < this.questions[i].alternatives.length; j++) {
              let alternative = this.questions[i].alternatives[j];
              if (alternative.answered && alternative.correct) {
                result++;
                break;
              }
            }
            // This question has no right answer, i.e. survey-mode
            if (!this.questions[i].alternatives.some((alternative) => alternative.correct)) {
              result++;
            }
          }
          (footer || that.footer).displayResult(result);
          that.panel.content[0].scrollTop = 0;
        },
        correctQuiz: function () {
          if (this.options.preview) {
            this.showResults();
          } else {
            that.remote
              .put(that.context.getId() + '/session/' + that.options.session_id + '/report', {
                answers: this.results,
                type: 'quiz',
              })
              .then((result) => {
                this.showResults();

                if (!this.redoable) {
                  this.options.locked = true;
                }

                if (that.options.setCheckmark) {
                  that.options.setCheckmark();
                }
                that.updateProgress(result);
                that.markAcceptedNode(that.context.getId(), result.state);
              })
              .catch((err) => {
                flash(i18n.__('error_behavior_save_failed'));
              });
          }
        },
        scrollToQuestion: function (question) {
          setTimeout(() => {
            const questionElement = this.$el.querySelectorAll(`li[data-question-id="${question.id}"]`)[0];
            const panel = that.panel.content[0];
            const panelHeaderSectionHeight = panel.querySelector('.pr2--panelHeaderSection').offsetHeight;
            const panelHeaderHeight = panel.querySelector('.pr2--panelHeader').offsetHeight;
            const contentHeight = panel.querySelector('.content-viewer').offsetHeight;
            panel.scrollTop =
              questionElement.offsetTop + panelHeaderSectionHeight + panelHeaderHeight + contentHeight - 20;
          }, 10);
        },
      },
      data: function () {
        return $.extend(
          {
            results: {},
            state: states.START,
            displayCorrect:
              that.data.locked || that.data.readOnly || (that.data.user && that.data.user.role == 'teacher'),
            displayResults: (that.data.user && that.data.user.role) == 'teacher' ? that.data.displayResults : true,
            currentQuestion: that.data.questions[0],
            options: {
              readonly: false,
              locked: that.data.locked || that.data.readOnly,
              preview: that.data.preview,
              upload: that.options.fileservice,
            },
          },
          Object.assign({}, that.data),
        );
      },
    });

    this.footer = new Vue({
      el: this.panel.content.find('.lp--js-quizFooterHook')[0],
      template: `
        <div class="lp--quizWidgetFooter">
            <button class="pr2--panelSaveBtn" v-if="!locked && state != states.START" v-bind:disabled="!(getAnsweredQuestions() == questions.length)" v-bind:class="stateDynamicClass" v-on:click="btnAction">{{stateBtnTitle}}</button>
              <div class="lp--quizWidgetFooterProgress" v-if="displayResults">
                {{correctString}}
                <div class="lp--quizWidgetProgressBar" v-bind:class="{'lp--quizWidgetProgressBarResult': (state == states.CORRECTED || locked)}" v-if="(state == states.ONGOING || state == states.CORRECTED) || locked">
                <div class="lp--quizWidgetProgressBarFill" v-bind:style="progressBarFillStyle"></div>
              </div>
              <a href="#" class="lp--quizWidgetFooterPrevious" :title="i18n('app_previous')" v-bind:class="dynamicStateHide(-1)" v-bind:disabled="!canGoPrevious" v-on:click.stop.prevent="changeQuestion(-1)" v-if="state == states.ONGOING"></a>
              <a href="#" class="lp--quizWidgetFooterNext" :title="i18n('app_next')" v-bind:class="dynamicStateHide(1)" v-bind:disabled="!canGoNext" v-on:click.stop.prevent="changeQuestion(1)" v-if="state == states.ONGOING"></a>
            </div>
        </div>
      `,
      methods: {
        i18n: function (str) {
          return i18n.__(str);
        },
        changeQuestion: function (direction) {
          that.editor.stepQuestion(direction);
        },
        btnAction: function (ev) {
          $(ev.target).blur();
          switch (this.state) {
            case states.START:
              that.editor.start();
              this.state = states.ONGOING;
              break;
            case states.ONGOING:
              that.editor.correctQuiz();
              break;
            case states.CORRECTED:
              this.reset();
              break;
          }
        },
        reset: function () {
          this.result = 0;
          this.currentIndex = 0;
          this.state = states.START;
          that.editor.reset();
        },
        questionUpdated: function (questions) {
          this.questions = questions;
          this.state = states.ONGOING;
        },
        setQuestionIndex: function (idx) {
          this.currentIndex = idx;
        },
        displayResult: function (result) {
          this.result = result;
          this.state = states.CORRECTED;
          if (!this.redoable) {
            this.locked = true;
          }
        },
        getAnsweredQuestions: function () {
          let answerCount = 0;
          for (var i = 0; i < this.questions.length; i++) {
            let question = this.questions[i];
            for (var j = 0; j < question.alternatives.length; j++) {
              if (question.alternatives[j].answered) {
                answerCount++;
                break;
              }
            }
          }
          return answerCount;
        },
        dynamicStateHide: function (direction) {
          return {
            'lp--quizWidgetFooterBtnInactive': !(direction == -1
              ? this.currentIndex - 1 > -1
              : this.currentIndex + 1 < this.questions.length),
          };
        },
      },
      mounted: function () {
        if (that.data.results && Object.keys(that.data.results).length > 0) {
          that.editor.showResults(this);
        }
      },
      computed: {
        progressBarFillStyle: function () {
          let answerCount = this.getAnsweredQuestions();
          if (this.locked) {
            return { width: (this.result / this.questions.length) * 100 + '%' };
          } else {
            switch (this.state) {
              case states.ONGOING:
                return {
                  width: (answerCount / this.questions.length) * 100 + '%',
                };
              case states.CORRECTED:
                return {
                  width: (this.result / this.questions.length) * 100 + '%',
                };
            }
          }
        },
        canGoPrevious: function () {
          return this.currentIndex - 1 > -1;
        },
        canGoNext: function () {
          return this.currentIndex + 1 < this.questions.length;
        },
        stateDynamicClass: function () {
          return {
            'lp--quizWidgetCorrectBtn': this.state == states.ONGOING,
          };
        },
        stateBtnTitle: function () {
          switch (this.state) {
            case states.START:
              return i18n.__('app_start');
            case states.ONGOING:
              return i18n.__('app_correct');
            case states.CORRECTED:
              return i18n.__('app_reset');
          }
        },
        correctString: function () {
          if (this.locked) {
            return i18n.__('quiz_correcting_result', this.result, this.questions.length);
          } else {
            switch (this.state) {
              case states.START:
                return i18n.__('quiz_question_count', this.questions.length);
              case states.ONGOING:
                let answerCount = this.getAnsweredQuestions();
                return i18n.__('quiz_ongoing_question_count', answerCount, this.questions.length);
              case states.CORRECTED:
                return i18n.__('quiz_correcting_result', this.result, this.questions.length);
            }
          }
        },
      },
      data: function () {
        return {
          currentIndex: 0,
          result: 0,
          redoable: that.data.redoable,
          questions: that.data.questions,
          state: states.START,
          locked: that.data.locked,
          preview: that.data.preview,
          displayResults: that.data.displayResults !== undefined ? that.data.displayResults : true,
          states: states,
        };
      },
    });
  }

  attach() {
    super.attach();

    this.panel.content.find('.lp--js-nodeComment').on('keypress ' + Utils.tapInteractionEvent + '.comments', (ev) => {
      $(document).trigger(Comments.EventTriggerName, {
        entity_uuid: this.context.getId(),
        entity_type: 'node',
      });
    });

    this.panel.content
      .find('.lp--js-triggerComment')
      .on('keypress ' + Utils.tapInteractionEvent + '.comments', (ev) => {
        $(ev.target).blur();
        $(document).trigger(Comments.EventTriggerName, {
          entity_uuid: $(ev.target).closest('[id]')[0].id,
          entity_type: 'quiz_report',
        });
      });

    this._setup();
  }

  detach() {
    super.detach();
    this.panel.content.find('.comment').off('.comments');
    this.panel.content.find('.lp--js-nodeComment').off('.comments');
  }
}
